import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId }, { headers: { "X-Session-ID": sessionId } });
        await checkAuth();
        const target = res.data.platform_role === "platform_owner" ? "/platform" : "/dashboard";
        window.history.replaceState({}, "", target);
        navigate(target, { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, checkAuth]);

  return <div className="min-h-screen bg-[#050505]" data-testid="auth-callback" />;
}
